import React, {useEffect} from 'react';
import useLocalization from '../../../Localization';
import {Row, Col} from 'antd';

import './index.css';
import CommonJobListing from './CommonJobListing';
import SectionLayout from './../../CommonComponents/Layout/sectionLayout';
import CommonHeroText from '../../CommonComponents/CommonHeroText';
const UserJobsComponent = (props) => {
  const {ApplicationString} = useLocalization();
  const {
    allJobsData,
    setAllJobsData,
    page,
    setPage,
    jobFeesOptions,
    zeroFeeData,
    fetchNewData,
    setFetchNewData,
  } = props;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowJobsListingPage'>
        <Col span={24}>
          <CommonHeroText
            heading={ApplicationString['userJobsComponentPage.heading']}
            subheading={''}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <span className='jobListingPageContentHeading'>
              {ApplicationString['userJobsComponent.subheading.part1']}
              {ApplicationString['userJobsComponent.subheading.part2']}
            </span>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <CommonJobListing
            allJobsData={allJobsData}
            setAllJobsData={setAllJobsData}
            page={page}
            setPage={setPage}
            zeroFeeData={zeroFeeData}
            jobFeesOptions={jobFeesOptions}
            fetchNewData={fetchNewData}
            setFetchNewData={setFetchNewData}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserJobsComponent;
